function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Capitan notification.js v1.0.0
 *
 * Copyright brandung GmbH & Co.KG
 * http://www.brandung.de/
 *
 *
 * Date: 2019-11-27
 * MIT License (MIT)
 */
import CapSmartResize from "../../code/js/Capitan/es6/CapSmartResize";
var _ = {
  defaults: {
    componentSelector: '.image-gallery',
    classes: {
      next: '.swiper-button-next',
      prev: '.swiper-button-prev'
    }
  }
};
var o = _.defaults;

var dynamicArrows = function dynamicArrows(component) {
  Promise.all(Array.from(component.querySelectorAll('img')).filter(function (img) {
    return !img.complete;
  }).map(function (img) {
    return new Promise(function (resolve) {
      img.onload = img.onerror = resolve;
    });
  })).then(function () {
    var el = component.querySelector('img');
    var buttonNext = component.querySelector('.swiper-button-next');
    var buttonPrev = component.querySelector('.swiper-button-prev');
    if (!el || !buttonNext || !buttonPrev) return;
    buttonNext.style.top = " ".concat(el.offsetHeight / 2, "px ");
    buttonPrev.style.top = " ".concat(el.offsetHeight / 2, "px");
  });
};
/**
 * initialize the component
 * @export function
 */


export function init() {
  if (document.querySelector(o.componentSelector)) {
    if (document.querySelector(o.componentSelector).parentElement.classList.contains("customer-bar--autoplay")) {
      return;
    } // Initialize the notification component.


    var components = document.querySelectorAll(o.componentSelector); // Grab all notifications on a page and iterate through their close buttons/links

    _toConsumableArray(components).forEach(function (component) {
      dynamicArrows(component);
    });
  }

  CapSmartResize(function () {
    var components = document.querySelectorAll(o.componentSelector); // Grab all notifications on a page and iterate through their close buttons/links

    _toConsumableArray(components).forEach(function (component) {
      dynamicArrows(component);
    });
  });
}